<template>
  <div>
    <div class="content">
      <div class="wrapper-x-40">
        <div
          v-if="settings.fast_access && settings.fast_access.length > 0"
          class="mb-8"
        >
          <h2 class="mb-4 h1">{{$t('admin.views.index.fast_access')}}</h2>
          <div class="fast_access__list">
            <router-link
              :to="fab.link"
              class="fast_access__item"
              v-for="fab in settings.fast_access"
              :key="`fabs-${fab.code}`"
            >
              <img
                :src="fab.image"
                class="fast_access__icon"
              />
              <span class="fast_access__title text-sm font-medium">{{
                fab.title
              }}</span>
            </router-link>
          </div>
        </div>

        <h1 class="mb-4">{{$t('admin.views.index.last_orders')}}</h1>
        <div>
          <div>
            <div
              class="element-list table-list-wrapper"
              v-if="orders"
            >
              <table>
                <thead>
                  <tr>
                    <th class="number">{{ $t('main.column_order_number') }}:</th>
                    <th class="date">{{ $t('main.column_date') }}:</th>
                    <th class="client">{{ $t('main.column_client') }}:</th>
                    <th class="phone">{{ $t('main.column_phone') }}:</th>
                    <th class="download-to-pdf">{{ $t('main.column_download_pdf') }}:</th>
                    <th class="total">{{ $t('main.column_cost') }}:</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="order in orders"
                    :key="order.order_id"
                  >
                    <td class="number">
                      <router-link
                        class="underline"
                        :to="{
                          name: 'order_detail',
                          params: {
                            order_id: order.order_id,
                          },
                        }"
                      >
                        {{ order.order_id }}
                      </router-link>
                    </td>
                    <td class="date">
                      {{ order.date }}
                    </td>
                    <td class="client">{{ order.name }}</td>
                    <td class="phone">{{ order.phone }}</td>
                    <td class="download-to-pdf text-center">
                      <a
                        :href="`/generate-pdf/${order.order_id}`"
                        class=" inline-flex"
                      >
                        <span
                          class="icon-download-pdf"
                          style="
                            background-image: url('/images/icons/icon-pdf.svg');
                          "
                        ></span>
                      </a>
                    </td>
                    <td class="total">
                      {{ $toCurrency(parseFloat(order.total)) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Index",
  data() {
    return {};
  },
  created() {
    this.$store.dispatch("orders/fetch");
  },
  computed: {
    settings() {
      return this.$store.state.settings.settings;
    },
    orders() {
      return this.$store.state.orders.orders;
    },
  },
  methods: {},
};
</script>
<style scoped>
th.total,
td.total {
  text-align: right;
}
</style>

